import { CloseCircleOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Radio,
  Row,
  Upload,
  message,
  notification,
} from "antd";
import React, { useContext } from "react";
import InputText from "../../Components/Input";
import Label from "../../Components/label";
import { BASE } from "../../Redux/Utils/httpInterceptor";
import {
  getDetails,
  uploadDocument,
  saveDetails,
  getUserBranchAllocationFlag,
} from "../../Redux/Services/dashboard";
import { ApplicantOptions } from "../../data/ApplicantType";
import { ApplicantOptionsKLI } from "../../data/KLIOption";
import RootContext from "../../context/RootContext";
import { onlyNumericRegex } from "../../regex";
import { useNavigate } from "react-router-dom";

const CaseStatus = (props) => {
  const [form] = Form.useForm();
  const [applicantList, setApplicantList] = React.useState([]);
  const [showContent, setShowContent] = React.useState(false);
  const [freezeMsg, setFreezeMsg] = React.useState("");
  const [fileList, setFileList] = React?.useState({});
  const [imagePath, setImagePath] = React?.useState("");
  const [showDocument, setShowDocument] = React?.useState(false);
  const [btnDisable, setBtnDisable] = React?.useState(true);
  const { heading, setHeading } = useContext(RootContext);
  const navigate = useNavigate()

  React.useEffect(()=>{
     setHeading("Support Module");
     fetchFlagApi()
  },[])


  const fetchFlagApi = async()=>{
    const res = await getUserBranchAllocationFlag({
      employeeId: localStorage?.getItem("empId"),
      moduleName: "Support Module",
      purpose: "Support",
    });

    if(!res?.error){
      res?.data?.userBranchAllocationFlag
        ? setBtnDisable(false)
        : setBtnDisable(true);
    }
  }
  
  const handleFormChange = (changedFields, allFields) => {
    if (changedFields?.action) {
      if (allFields?.appId) {
        setShowContent(false);
        fetchGetApi(allFields?.appId, changedFields?.action);
      } else {
        notification.error({ message: "Please Enter Applicant ID" });
      }
    }
  };

  const fetchGetApi = async (appId, actionType) => {
    const res = await getDetails({
      appId: appId,
      action: actionType,
    });
    console.log(res?.data?.coapplicantList);
    const list = res?.data?.coapplicantList?.map((item) => {
      return {
        label: item?.coapplicantName,
        value: item?.coppalicantUniqueid,
      };
    });
    setApplicantList(list);
    res?.data?.supportFreezeFlag == false && setShowContent(true);
    console.log(res?.data , "xxx")
    if (res?.data?.supportFreezeFlag) {
      setFreezeMsg(res?.data?.errorMsg);
    } else {
      setFreezeMsg("");
    }
  };
  
  const propsUpload = {
    maxCount: 1,
    multiple: false,
    showUploadList: false,
    
    beforeUpload: (file) => {
      console.log(file.type , "type");
      console.log(file.type == "application/pdf", "type");
      const isPDF = file.type == "application/pdf";
      if (file.type != "application/pdf") {
        notification.error({ message: `${file.name} is not a pdf file` });
      } else {
        setFileList(file);
        uploadDocument({
          data: {
            documentInfo: JSON.stringify({
              appId: form.getFieldValue("appId"),
              employeeId: localStorage?.getItem("empId"),
              action: form.getFieldValue("action"),
            }),
          },
          file,
        }).then((re) => {
          if (re?.data?.error) {
            form.resetFields(["document"]);
          } else {
            setImagePath(re?.data?.data?.filePath);
            //  setShowUploaded(true);
            setShowDocument(true);
          }
        });
      }
      
      return false;
    },

    onChange(info) {
      if (info.file.status !== "uploading") {
      }
      
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  
  const handleClose = () => {
    setShowDocument(false);
  };
  const onFinish = async (values) => {
    console.log(values)
    const data = await { ...values, employeeId: localStorage?.getItem("empId") };
    const res = await saveDetails(data)
    if(res){
      form.resetFields();
      setShowContent(false);
    }
  };

  const onNavigateHandler = async ()=>{
 navigate("/delaerMapping");
  }

  return (
    <Form
      initialValues={{
        remember: true,
      }}
      name="dynamic_form_nest_item"
      onFinish={onFinish}
      autoComplete="off"
      form={form}
      onValuesChange={handleFormChange}
    >
      <Row
        style={{ margin: "3%"}}
        type={"flex"}
        gutter={[20, 20]}
      >
        <div className="dashBoardBtn">
          <Button disabled={btnDisable} onClick={onNavigateHandler} className={"reset-button"}>
           Dealer Mapping
          </Button>
          <Button disabled={btnDisable}  onClick={() => navigate("/cwccustomernotification")} className={"reset-button"} style={{marginLeft:"20px"}}>
           Customer Notification
          </Button>
        </div>
      </Row>
      <Card
        title=""
        bordered={true}
        style={{ margin: "3%", boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px" }}
      >
        <Row gutter={[32, 0]}>
          <Col lg={12}>
            <Label label="Enter Applicant Id" value={""} />
            <Form.Item
              name={"appId"}
              style={{ maxWidth: "320px" }}
              rules={[
                {
                  required: false,
                  message: `Applicant Id is mandatory`,
                },
                {
                  pattern: onlyNumericRegex,
                  message: "Invalid Applicant ID",
                },
              ]}
            >
              <InputText label="Applicant ID" />
            </Form.Item>
          </Col>{" "}
          <Col lg={12}>
            <Label label="Select Applicant Removal Type" value={""} />
            <Form.Item
              style={{ maxWidth: "320px" }}
              name={"action"}
              rules={[
                {
                  required: false,
                  message: `Type is mandatory`,
                },
              ]}
            >
              <InputText
                type="dropdown"
                label="Applicant Removal Type"
                options={btnDisable ? ApplicantOptionsKLI : ApplicantOptions}
              />
            </Form.Item>
          </Col>{" "}
        </Row>
        <br />
        {showContent && (
          <>
            <Label label="Action :" value={""} />
            <Row gutter={[16, 24]}>
              <Col span={8}>
                <b>
                  Do you want to remove{" "}
                  {form.getFieldValue("action")?.split(" ")?.[0]}
                </b>
              </Col>{" "}
              <Col span={16}>
                <Form.Item
                  name={"removeCoapplicantKli"}
                  rules={[
                    {
                      required: true,
                      message: "Please Select an Option",
                    },
                  ]}
                >
                  <Radio.Group
                    name="removeCoapplicantKli"
                    defaultValue={""}
                    // disabled={caseFreeze || userFreeze}
                  >
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            {form.getFieldValue("action") !== "KLI Removal" ? (
              <Row>
                <Col lg={12}>
                  <Label
                    label={`Select ${
                      form.getFieldValue("action")?.split(" ")?.[0]
                    } ID`}
                    value={""}
                  />
                  <Form.Item
                    name={"coapplicantUniqueid"}
                    style={{ maxWidth: "320px" }}
                    rules={[
                      {
                        required: true,
                        message: `Type is mandatory`,
                      },
                    ]}
                  >
                    <InputText
                      type="dropdown"
                      label="Applicant Removal Type"
                      options={applicantList}
                    />
                  </Form.Item>
                </Col>{" "}
              </Row>
            ) : !showDocument ? (
              <>
                <Form.Item
                  name={"document"}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Document",
                    },
                  ]}
                >
                  <Upload {...propsUpload}>
                    <Button icon={<UploadOutlined />}>Mail Approval PDF</Button>
                  </Upload>
                </Form.Item>
              </>
            ) : (
              <div>
                <div style={{ position: "relative", width: 300 }}>
                  {imagePath?.split(".")?.pop() == "pdf" ? (
                    <div style={{ cursor: "pointer" }}>
                      <a
                        style={{ color: "#334e9e" }}
                        href={imagePath?.replace("/var/www/html", BASE)}
                        target="_blank"
                      >
                        {imagePath?.replace(/^.*[\\\/]/, "")}
                      </a>
                    </div>
                  ) : (
                    <>
                      <img
                        width="300"
                        src={imagePath?.replace("/var/www/html", BASE)}
                        alt="closeIcon"
                      ></img>
                      <CloseCircleOutlined
                        onClick={handleClose}
                        style={{
                          position: "absolute",
                          top: -5,
                          right: -5,
                          fontSize: 20,
                          color: "red",
                          background: "white",
                          borderRadius: "50%",
                          cursor: "pointer",
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            )}

            <Row justify="center" align="middle">
              <Button
                htmlType="submit"
                className="reset-button"
                // disabled={caseFreeze || userFreeze}
              >
                Submit
              </Button>
            </Row>
          </>
        )}
        <Row>
          <p style={{ color: "red" }}>
            <b>{freezeMsg}</b>
          </p>
        </Row>
      </Card>
    </Form>
  );
};

export default CaseStatus;
